/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AptosDelegationNodeListInfo } from '../models/AptosDelegationNodeListInfo';
import type { AptosNodeDetailInfo } from '../models/AptosNodeDetailInfo';
import type { AptosNodeListInfo } from '../models/AptosNodeListInfo';
import type { AptosNodeLocationListInfo } from '../models/AptosNodeLocationListInfo';
import type { AptosNodeSummaryInfo } from '../models/AptosNodeSummaryInfo';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class AptosNodeControllerService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns AptosNodeDetailInfo OK
     * @throws ApiError
     */
    public getNodeDetail1({
        address,
    }: {
        address: string,
    }): CancelablePromise<AptosNodeDetailInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/aptos/node',
            query: {
                'address': address,
            },
        });
    }

    /**
     * @returns AptosNodeSummaryInfo OK
     * @throws ApiError
     */
    public getAptosNodeSummary(): CancelablePromise<AptosNodeSummaryInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/aptos/node/summary',
        });
    }

    /**
     * @returns AptosNodeLocationListInfo OK
     * @throws ApiError
     */
    public getAptosNodeLocationList(): CancelablePromise<AptosNodeLocationListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/aptos/node/location/list',
        });
    }

    /**
     * @returns AptosNodeListInfo OK
     * @throws ApiError
     */
    public getAptosNodeList({
        sortField = 'VOTING_POWER',
        sortDirection = 'DESC',
        page = 1,
        size = 25,
    }: {
        sortField?: 'VOTING_POWER' | 'REWARDS_PERFORMANCE' | 'LAST_EPOCH_PERFORMANCE',
        sortDirection?: 'ASC' | 'DESC',
        page?: number,
        size?: number,
    }): CancelablePromise<AptosNodeListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/aptos/node/list',
            query: {
                'sortField': sortField,
                'sortDirection': sortDirection,
                'page': page,
                'size': size,
            },
        });
    }

    /**
     * @returns AptosDelegationNodeListInfo OK
     * @throws ApiError
     */
    public getAptosDelegationNodeList({
        sortField = 'REWARD_EARNED',
        sortDirection = 'DESC',
        page = 1,
        size = 25,
    }: {
        sortField?: 'DELEGATION_AMOUNT' | 'COMMISSION' | 'DELEGATORS' | 'REWARD_EARNED',
        sortDirection?: 'ASC' | 'DESC',
        page?: number,
        size?: number,
    }): CancelablePromise<AptosDelegationNodeListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/aptos/node/delegation/list',
            query: {
                'sortField': sortField,
                'sortDirection': sortDirection,
                'page': page,
                'size': size,
            },
        });
    }

}
